module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_02-900-a66aeed9da26dbf5561ee530ddeebc98.png";